// New: UI_REVAMP

import { create } from 'zustand';

export const useBetTwo3DStore = create((set) => ({
	selectedNumbers: [],
	hotNumbers: [],
	soldOutNumbers: [],
	addSelectedNumbers: (numbers) =>
		set((state) => ({ selectedNumbers: [...state.selectedNumbers, ...numbers] })),
	removeSelectedNumber: (number) =>
		set((state) => ({
			selectedNumbers: state.selectedNumbers.filter((n) => n !== number),
		})),
	setNumberLimit: (data) =>
		set({
			hotNumbers: data?.hotNumber || [],
			soldOutNumbers: data?.soldOut || [],
		}),
	clearSelectedNumbers: () => set({ selectedNumbers: [] }),
}));
